window.config = {
    debug: false,
    apiEndpoint: 'https://api.zcooly.se',
    loginSiteSV: 'https://login.zcooly.se',
    loginSiteEN: 'https://login.zcooly.com',
};
